import { UserState } from './types';

export const initialState: UserState = {
  idToken: null,
  refreshToken: null,
  greenroomToken: null,
  user: null,
  signingOut: false,
  changingChannels: false,
  channelType: undefined,
};
